import reducer from './reducer';
import * as escalatedReportActions from './reducer';

export { escalatedReportActions };

export default reducer;
